module.exports = "//public.zight.com/packs/media/images/icons-clipboard-2-1e8642cf9782bfbc82cccfea0dfdd020.svg";